import React from "react";
import { Container, Button } from "react-bootstrap";

const InfoPage = () => {
  return (
    <main className="bg-light text-dark py-5">
      <Container className="mx-auto px-3" style={{ maxWidth: "900px" }}>
        {/* Title */}
        <h2 className="text-center fw-semibold text-primary mb-4">
          Welcome to the BPMN-Chatbot++
        </h2>

        {/* Demo Video */}
        <section className="mt-5">
          <h3 className="fw-semibold text-primary border-bottom border-2 border-primary pb-1">
            Demo Video
          </h3>
          <div className="ratio ratio-16x9 mt-3 rounded overflow-hidden">
            <iframe
              src="https://www.youtube.com/embed/c--1AdTAS-4?si=8kpUe-ObQ49yCQ26?autoplay=1&rel=0"
              title="BPMN-Chatbot demo"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </section>

        {/* Live Demo */}
        <section className="mt-5">
          <h3 className="fw-semibold text-primary border-bottom border-2 border-primary pb-1">
            Live Demo
          </h3>
          <p className="mt-2">
            Note: An API Key for OpenAI or alternatives such as openrouter.ai is
            required.
          </p>
          <Button
            variant="primary"
            className="mt-2 fw-semibold rounded-3 px-4 py-2"
            href="https://bpmnchatbot.aau.at/pubserv/BPMN-Chatbot-Beta/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Live Demo
          </Button>
        </section>

        {/* Publications */}
        <section className="mt-5">
          <h3 className="fw-semibold text-primary border-bottom border-2 border-primary pb-1">
            Publications
          </h3>
          <ul className="mt-3">
            <li className="mt-2">
              Safan, A. & Köpke, J.{" "}
              <em>
                <a
                  href="https://isys.uni-klu.ac.at/PDF/BPMN_ChatbotPP_ER_Forum_25.pdf"
                  className="link-primary text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  A Framework for LLM-Based Conceptual Modeling: Application to
                  BPMN Collaboration Diagrams
                </a>
              </em>{" "}
              ER Forum in ER2025, Poitiers, France. [
              <a
                href="https://isys.uni-klu.ac.at/PDF/BPMN_ChatbotPP_ER_Forum_25.pdf"
                className="link-primary text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                accepted version (PDF)
              </a>
              ]
            </li>

            <li className="mt-2">
              Safan, A. & Köpke, J.{" "}
              <em>
                <a
                  href="https://isys.uni-klu.ac.at/PDF/BPM_DEMO_25_BPMNChatbot.pdf"
                  className="link-primary text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  BPMN-Chatbot++: LLM-Based Modeling of Collaboration Diagrams
                  with Data
                </a>
              </em>{" "}
              In Proceedings of the BPM 2025 Demos & Resources Forum, Seville,
              Spain. [
              <a
                href="https://isys.uni-klu.ac.at/PDF/BPM_DEMO_25_BPMNChatbot.pdf"
                className="link-primary text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                accepted version (PDF)
              </a>
              ]
            </li>

            <li className="mt-2">
              J. Köpke, A. Safan,{" "}
              <em>
                <a
                  href="https://scholar.google.com/scholar?oi=bibs&cluster=14766798943026948274&btnI=1&hl=en"
                  className="link-primary text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Introducing the BPMN-Chatbot for Efficient LLM-Based Process
                  Modeling
                </a>
              </em>
              , in BPM 2024 Demos, 2024
            </li>

            <li className="mt-2">
              J. Köpke, A. Safan,{" "}
              <a
                href="https://drive.google.com/file/d/1EVl0SVKeyTnsw6pb59WgvL1K8Y88weRk/view"
                className="link-primary text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                Efficient LLM-Based Conversational Process Modeling
              </a>
              , in NLP4BPM Workshop at BPM 2024, 2024
            </li>
          </ul>
        </section>

        {/* Contact */}
        <section className="mt-5">
          <h3 className="fw-semibold text-primary border-bottom border-2 border-primary pb-1">
            Contact
          </h3>
          <ul className="mt-3">
            <li>
              <a
                href="https://www.aau.at/team/koepke-julius/"
                className="link-primary text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                Julius Köpke
              </a>
            </li>
            <li>
              <a
                href="https://www.aau.at/team/safan-aya-mohamed-abdelaziz/"
                className="link-primary text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                Aya Safan
              </a>
            </li>
          </ul>
        </section>
      </Container>
    </main>
  );
};

export default InfoPage;
